import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { vars } from "@pancakeswap/ui/css/vars.css";
import React from "react";
import { Box, Flex } from "../Box";
import { Link } from "../Link";
import { StyledFooter, StyledIconMobileContainer, StyledList, StyledListItem, StyledText } from "./styles";
import { LogoIcon } from "../Svg";
import { Text } from "../Text";
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var tosAndPrivacy = [
        {
            label: "Terms of Service",
            href: "https://alienbase.xyz/terms"
        },
        {
            label: "Privacy Policy",
            href: "https://alienbase.xyz/privacy-policy"
        }
    ];
    return /*#__PURE__*/ _jsxs(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                flexDirection: "column",
                width: [
                    "100%",
                    null,
                    "100%;"
                ],
                children: [
                    /*#__PURE__*/ _jsxs(StyledIconMobileContainer, {
                        display: [
                            "block",
                            null,
                            "none"
                        ],
                        children: [
                            /*#__PURE__*/ _jsx(LogoIcon, {
                                mr: "15px"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                color: "white",
                                fontSize: "18px",
                                className: "syncopate",
                                textTransform: "uppercase",
                                fontWeight: 700,
                                children: "Alienbase"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        borderBottom: "1px solid ".concat(vars.colors.cardBorder),
                        mb: [
                            "15px",
                            null,
                            "15px"
                        ],
                        children: /*#__PURE__*/ _jsxs(Flex, {
                            mt: "50px",
                            order: [
                                2,
                                null,
                                1
                            ],
                            flexDirection: [
                                "column",
                                null,
                                "row"
                            ],
                            justifyContent: "space-between",
                            alignItems: "center",
                            pb: [
                                "20px",
                                null,
                                "20px"
                            ],
                            width: [
                                "100%",
                                null,
                                "100%"
                            ],
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    display: [
                                        "none",
                                        null,
                                        "block"
                                    ],
                                    children: /*#__PURE__*/ _jsxs(Flex, {
                                        width: "min-content",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ _jsx(LogoIcon, {
                                                mr: "15px"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                color: "white",
                                                fontSize: "18px",
                                                className: "syncopate",
                                                textTransform: "uppercase",
                                                fontWeight: 700,
                                                children: "Alienbase"
                                            })
                                        ]
                                    })
                                }),
                                items === null || items === void 0 ? void 0 : items.map(function(item) {
                                    var ref;
                                    /*#__PURE__*/ return _jsxs(StyledList, {
                                        children: [
                                            item.label && /*#__PURE__*/ _jsx(StyledListItem, {
                                                children: item.label
                                            }),
                                            (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                                var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                                return /*#__PURE__*/ _jsx(StyledListItem, {
                                                    children: href ? /*#__PURE__*/ _jsx(Link, {
                                                        fontWeight: 500,
                                                        fontSize: 18,
                                                        "data-theme": "dark",
                                                        href: href,
                                                        target: "_blank",
                                                        rel: "noreferrer noopener",
                                                        color: isHighlighted ? vars.colors.warning : "text",
                                                        children: label
                                                    }) : /*#__PURE__*/ _jsx(StyledText, {
                                                        children: label
                                                    })
                                                }, label);
                                            })
                                        ]
                                    }, item.label);
                                }),
                                /*#__PURE__*/ _jsx(Flex, {
                                    style: {
                                        gap: "10px"
                                    },
                                    alignItems: "center",
                                    mt: [
                                        "30px",
                                        "30px",
                                        "0px"
                                    ],
                                    justifyContent: "center",
                                    children: tosAndPrivacy.map(function(param) {
                                        var label = param.label, href = param.href;
                                        return /*#__PURE__*/ _jsx(StyledText, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                fontWeight: 500,
                                                fontSize: 14,
                                                "data-theme": "dark",
                                                href: href,
                                                target: "_blank",
                                                rel: "noreferrer noopener",
                                                color: "text",
                                                children: label
                                            })
                                        }, label);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: [
                    "center",
                    null,
                    "space-between"
                ],
                alignItems: "center",
                flexDirection: [
                    "column",
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "rgba(159, 169, 185, 0.60)",
                        fontSize: 12,
                        textAlign: [
                            "center",
                            null,
                            "left"
                        ],
                        children: "\xa9 2023 Alien Base. All rights reserved"
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        mt: [
                            "10px",
                            "10px",
                            "0px"
                        ],
                        color: "rgba(159, 169, 185, 0.60)",
                        textAlign: [
                            "center",
                            null,
                            "right"
                        ],
                        fontSize: 12,
                        children: [
                            "Alien Base is developed and managed ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "independently of the Coinbase / Base team"
                        ]
                    })
                ]
            })
        ]
    }));
};
/* After the last flex to show cake price and buy cake button
<Flex order={[1, null, 2]} mb={["24px", null, "0"]} justifyContent="space-between" alignItems="center">
            <Box mr="20px">
              <CakePrice cakePriceUsd={cakePriceUsd} color="textSubtle" />
            </Box>
            <Button
              data-theme="light"
              as="a"
              href="https://pancakeswap.finance/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56"
              target="_blank"
              scale="sm"
              endIcon={<ArrowForwardIcon color="backgroundAlt" />}
            >
              {buyCakeLabel}
            </Button>
          </Flex>
*/ export default MenuItem;
